import { render, staticRenderFns } from "./submissionplan.vue?vue&type=template&id=9a329ed0&scoped=true"
import script from "./submissionplan.vue?vue&type=script&lang=js"
export * from "./submissionplan.vue?vue&type=script&lang=js"
import style0 from "./submissionplan.vue?vue&type=style&index=0&id=9a329ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a329ed0",
  null
  
)

export default component.exports